import $ from 'jquery';

$(document).ready(function(){
	$("#navbar-mobile-toggler").click(function(){
		$("#navbar-mobile-toggler").css("display",'none');
		$("#navbar-mobile").show("fast");
		$(".menu-mobile").animate({left : "0"}, "fast");
		$(".menu-mobile").css("border","none");
		$("body").css("overflow","hidden");
	});
	$("#menu-button-close").click(function(){
		$("#navbar-mobile-toggler").css("display","block");
		$("#navbar-mobile").hide("fast");
		$(".menu-mobile").animate({left : "-69%"}, "fast");
		$("body").css("overflow","auto");
	});
	$("#dropdown-menu").hover(function(){
		$(".dropdown-menu").slideToggle("fast");
		$(".background-dropdown").fadeToggle("fast");
	});
	$(window).scroll(function(){
		if($(this).scrollTop() > 20){
			$(".navbar").css("background","rgba(46,23,69,1)");
			$(".navbar").css("transition","0.5s");
		}else{
			$(".navbar").css("background","rgba(0,0,0,.3)");
			$(".navbar").css("transition","0.5s");
		}
	});
	$("#text-location").click(function(){
		$(".modal-kota").addClass("d-none");
		$(".modal-provinsi").removeClass("d-none");
		$("#modal-location").modal("show");
	});
	$("#kembali-provinsi").click(function(){
		$(".modal-kota").addClass("d-none");
		$(".modal-provinsi").removeClass("d-none");
	});
	$("#modal-kota").click(function(){
		$(".modal-kota").removeClass("d-none");
		$(".modal-provinsi").addClass("d-none");
	});
	$(".modal-body a").click(function(e){
		e.preventDefault();
	});
});

export default {

}
